import { render, staticRenderFns } from "./CalendarDialog.vue?vue&type=template&id=5a2088e2&"
import script from "./CalendarDialog.vue?vue&type=script&lang=js&"
export * from "./CalendarDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports